import { render, staticRenderFns } from "./BlockIcon.vue?vue&type=template&id=8155871a&scoped=true&"
import script from "./BlockIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BlockIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8155871a",
  null
  
)

export default component.exports